var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTubeStandSmWide(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1456,
    height: 144,
    viewBox: "0 0 1456 144",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 129,
    width: 1450,
    height: 10,
    fill: "#00AEEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0691 123H1440.93L1453 129H3L15.0691 123Z",
    fill: "#99DFF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 1H1453V11H3V1Z",
    fill: "#00AEEF"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 280,
    cy: 124.5,
    rx: 22,
    ry: 1.5,
    fill: "black",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 169.5,
    cy: 124.5,
    rx: 22.5,
    ry: 1.5,
    fill: "black",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 57.5,
    cy: 124.5,
    rx: 22.5,
    ry: 1.5,
    fill: "black",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 717,
    cy: 124.5,
    rx: 22,
    ry: 1.5,
    fill: "black",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 835,
    cy: 124.5,
    rx: 22,
    ry: 1.5,
    fill: "black",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 945.5,
    cy: 124.5,
    rx: 22.5,
    ry: 1.5,
    fill: "black",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1057,
    cy: 124.5,
    rx: 22,
    ry: 1.5,
    fill: "black",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1279.5,
    cy: 124.5,
    rx: 22.5,
    ry: 1.5,
    fill: "black",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1168,
    cy: 124.5,
    rx: 22,
    ry: 1.5,
    fill: "black",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1390,
    cy: 124.5,
    rx: 22,
    ry: 1.5,
    fill: "black",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 610,
    cy: 124.5,
    rx: 22,
    ry: 1.5,
    fill: "black",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 503,
    cy: 124.5,
    rx: 22,
    ry: 1.5,
    fill: "black",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 395.5,
    cy: 124.5,
    rx: 22.5,
    ry: 1.5,
    fill: "black",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1453 11.2161H3L9.53153 17.7476H29.126V14.482H87.9098V17.7476H140.162V14.4818H198.946V17.7476H251.198V14.4818H309.982V17.7476H362.234V14.4818H421.018V17.7476H473.27V14.4818H532.054V17.7476H584.306V14.4818H643.09V17.7476H695.342V14.4818H754.126V17.7476H806.379V14.4818H865.162V17.7476H917.415V14.4818H976.198V17.7476H1028.45V14.4818H1087.23V17.7476H1139.49V14.4818H1198.27V17.7476H1250.52V14.4818H1309.31V17.7476H1361.56V14.4818H1420.34V17.7476H1446.47L1453 11.2161Z",
    fill: "#008BC0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 14,
    width: 7,
    height: 112,
    fill: "#00AEEF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1430,
    y: 14,
    width: 7,
    height: 112,
    fill: "#00AEEF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 0,
    y: 0,
    width: 1456,
    height: 144,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTubeStandSmWide);
export default __webpack_public_path__ + "static/media/TubeStandSMWide.f2d2e6d07cb58eb3b67a7f1332daeb31.svg";
export { ForwardRef as ReactComponent };